import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const { user, status } = useSelector((state: any) => state.auth);

  if (status === "loading") {
    return <div>Loading...</div>;
  }

  return user ? children : <Navigate to="/login" replace />;
};
